import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { LockKey, ArrowLeft } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setBusy(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please sign in.");
      navigate("/login");
    } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#08111F] p-6 text-white">
      <div className="w-full max-w-sm rounded-2xl border border-white/10 bg-white/[0.03] p-6" data-testid="reset-page">
        <Link to="/login" className="mb-4 flex items-center gap-1 text-sm text-white/60"><ArrowLeft size={14} /> Back to sign in</Link>
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground"><LockKey size={24} weight="duotone" /></div>
        <h1 className="mt-4 font-display text-2xl font-semibold tracking-tight">Set a new password</h1>
        {!token && <p className="mt-2 text-sm text-red-300" data-testid="reset-no-token">This reset link is missing its token. Please request a new one.</p>}
        {error && <div data-testid="reset-error" className="mt-4 rounded-lg bg-destructive/20 px-3 py-2 text-sm text-red-300">{error}</div>}
        <form onSubmit={submit}>
          <label className="mt-5 block text-xs font-semibold uppercase tracking-wide text-white/50">New password</label>
          <input data-testid="reset-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters"
            className="mt-1.5 w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 outline-none focus:border-primary" />
          <label className="mt-4 block text-xs font-semibold uppercase tracking-wide text-white/50">Confirm password</label>
          <input data-testid="reset-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Re-enter password"
            className="mt-1.5 w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 outline-none focus:border-primary" />
          <button data-testid="reset-submit" disabled={busy || !token}
            className="mt-5 w-full rounded-full bg-primary py-3.5 font-semibold text-primary-foreground transition-transform hover:scale-[1.02] disabled:opacity-60">
            {busy ? "Updating…" : "Update password"}
          </button>
        </form>
      </div>
    </div>
  );
}
